import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { Dialog } from 'primereact/dialog';
import UpdatePassword from './Components/UpdatePassword';

const Profile = () => {
    const [profileInfo, setProfileInfo] = useState(null);
    const [showPasswordDialog, setShowPasswordDialog] = useState(false);

    const getProfileInfo = async () => {
        const userDetail = JSON.parse(localStorage.getItem('adminUser'));
        const userId = userDetail?.data?.userId;
        const response = await handleGetRequest(endPoints.getUserById(userId), true);
        setProfileInfo(response?.data);
    };
    useEffect(() => {
        getProfileInfo();
    }, []);

    const changePassword = () => {
        setShowPasswordDialog(true);
    };

    const onHide = () => {
        setShowPasswordDialog(false);
    };
    const onClose = () => {
        setShowPasswordDialog(false);
    };

    return (
        <div
            style={{
                margin: '200px auto',
                maxWidth: 600,
                background: '#fdfdfd',
                borderRadius: 16,
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                padding: '32px 24px'
            }}
        >
            <Dialog header={'Change Password'} visible={showPasswordDialog} onHide={onClose} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
                <UpdatePassword profileInfo={profileInfo} onHide={onHide} onClose={onClose} />
            </Dialog>
            <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <img
                    // src={profileInfo.profileImage || '/assets/layout/images/profile-image.png'}
                    alt="Profile"
                    style={{
                        width: 110,
                        height: 110,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '4px solid #dfe6ec',
                        marginBottom: 16
                    }}
                />
                {/* <h2 style={{ margin: 0, fontWeight: 700, fontSize: 24 }}>{profileInfo.name}</h2>
                <span style={{ color: '#7b8ca5', fontSize: 15 }}>{profileInfo.email}</span> */}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                <div className="p-float-label">
                    <InputText id="name" name="name" value={profileInfo?.name} readOnly style={{ width: '100%' }} />
                    <label htmlFor="name">Name</label>
                </div>

                <div className="p-float-label">
                    <InputText id="email" name="email" value={profileInfo?.email} readOnly style={{ width: '100%' }} />
                    <label htmlFor="email">Email</label>
                </div>

                <div className="p-float-label">
                    <InputText id="phone" name="phone" value={profileInfo?.phone} readOnly style={{ width: '100%' }} />
                    <label htmlFor="phone">Phone</label>
                </div>

                <div className="p-float-label">
                    <InputText id="role" name="role" value={profileInfo?.roleName} readOnly style={{ width: '100%', background: '#f4f6fa' }} />
                    <label htmlFor="role">Role</label>
                </div>
                <div className="justify-content-end">
                    <Button label="Update Password" icon="pi pi-pencil" onClick={() => changePassword()} className=" p-button-info p-button-sm w-3 " />
                </div>
            </div>
        </div>
    );
};

export default Profile;
